import React from "react";
import Header from "@/components/Header";
import { Plans } from "@/components/Plans";

export default function PlansPage() {
  return (
    <>
      <Header showProfile showLang />
      <Plans />
    </>
  );
}
